import { faBolt } from '@fortawesome/pro-solid-svg-icons';

// eslint-disable-next-line import/no-relative-packages
import { DeviceTypeTotals } from '../../../../universal-dashboard-api/src/Data-Processor/Entities/Interfaces/Summary';
import { DeviceGroupStyles } from '../../types';
import { formatPercentage, formatPower } from '../../utils/formatters';
import { Card } from './Card';
import { Header } from './Header';

type PowerCardProps = {
  data?: DeviceTypeTotals;
  deviceStyles?: DeviceGroupStyles;
  loading?: boolean;
};

export function PowerCard({ data, deviceStyles, loading }: PowerCardProps) {
  const totalPower = formatPower(data?.totalPower, 'M');
  return (
    <Card>
      <Header border icon={faBolt} loading={loading} title="Asset breakdown" />
      {!loading && data && deviceStyles && (
        <>
          <p className="text-lg font-medium">
            {totalPower.value}{' '}
            <span className="text-sm font-normal">{totalPower.unit}</span>
          </p>
          <div className="flex h-2 overflow-hidden rounded-full">
            {data.assetPowerBreakdown.map(({ type, value }) => (
              <div
                className={`h-full w-full ${deviceStyles[type].bg}`}
                key={type}
                style={{ width: `${(value / data.totalPower) * 100}%` }}
              />
            ))}
          </div>
          <table>
            <tbody>
              {data.assetPowerBreakdown.map(({ type, value }) => {
                const power = formatPower(Math.round(value), 'M');
                return (
                  <tr key={type}>
                    <td className="flex items-center gap-2 pb-1 pr-2">
                      <span
                        className={`inline-block h-2 w-2 rounded-full bg-fuschia-50 ${deviceStyles[type].bg}`}
                      />
                      {type}
                    </td>
                    <td className="whitespace-nowrap pb-1 pr-2 text-right">
                      {power.value}{' '}
                      <span className="text-xs">{power.unit}</span>
                    </td>
                    <td className="pb-1 text-right">
                      {formatPercentage(value / data.totalPower)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}
    </Card>
  );
}
